<form [formGroup]="signUpLoginForm" class="w-full grid gap-6 grid-cols-1 mt-12 md:mt-6 mb-12 md:mb-6" action="#">
  @if (isSubmitted && signUpLoginForm.invalid) {
    <div class="w-full bg-[#9730307f] h-10 border-l-2 border-l-error">
      <span class="text-xs min-h-full inline-flex items-center ml-3">{{ 'ERROR.INVALID_EMAIL.MESSAGE' | translate }}</span>
    </div>
  }

  <nrc-input-text
    [formControl]="signUpLoginForm.controls.email"
    [type]="'email'"
    [name]="'signup-email'"
    [id]="'signup-email'"
    [label]="'Email'"
    [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
    [invalidHint]="'ERROR.EMAIL_NOT_MATCHING.MESSAGE' | translate"
  />

  <nrc-input-password
    [formControl]="signUpLoginForm.controls.password"
    [name]="'signup-password'"
    [id]="'signup-password'"
    [label]="'Password'"
    [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
  />
</form>

<nrc-password-format-validator [password]="signUpLoginForm.controls.password.value" />

<div class="flex justify-end mt-8">
  <nrc-button
    class="relative"
    [label]="'Continue'"
    (clickEvent)="continue()"
  />
</div>
